// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> villas-at-old-four-four-one
// Generated: 2026-10-01T17:22:15.251Z
// Counts: 5 design, 88 content, 32 slot group, 5 collection binding, 9 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Where Modern Comfort Meets North Georgia Charm</h2><h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome Home to</h1><h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Villas at Old 441 places you in the heart of one of North Georgia's most scenic communities.</p><p>Explore the charm of downtown Demorest and nearby Cornelia, spend weekends hiking local trails, visit area wineries, enjoy parks and outdoor recreation, or discover local restaurants and shops—all just minutes from home. With convenient access to Highway 441 and nearby Piedmont University, everything you need is within easy reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore The Best of Northeast Georgia.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Peace &amp; Community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019df453-5388-7288-83df-6be3b7526f17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>Spaces Designed for Everyday Living</strong></span></h2><p>Whether you're starting your morning with a workout, cooling off by the pool, or spending an evening with friends in the beer garden, our community amenities are designed to help you enjoy life a little more every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>We'd Love to Welcome You Home</strong></span></h2><p>Whether you're ready to move soon or just beginning your apartment search, our friendly leasing team is here to help.</p><p>Come experience Villas at Old 441 in person, explore our available apartment homes, and discover why so many residents love calling our community home.</p><p>Schedule your tour today—we can't wait to meet you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Imagine Life Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything Close to Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe-2.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe-2.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>Find the Space That Fits Your Life</strong></span></h2><p>Whether you're looking for your first apartment, extra room to grow, or the perfect place to simplify your lifestyle, Villas at Old 441 offers spacious one, two, and three-bedroom floor plans designed with comfort and flexibility in mind.</p><p>Browse available homes and find the one that's right for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>See Yourself at Villas at Old 441</strong></span></h2><p>Take a closer look at the spaces where everyday moments happen.</p><p>From beautifully designed apartment homes to inviting community amenities, it's easy to picture yourself living, relaxing, and making memories here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/villas-at-old-441-apartments-with-pool-demorest-ga::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments with a pool in Demorest, GA? Look no further than the charming Villas at Old 441. Set amidst the beautiful backdrop of Habersham County, our community offers residents access to a refreshing pool—ideal for relaxation and leisure.</p><p>The Villas at Old 441 go beyond just a pool. Indulge in a range of<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\"> first-class amenities</a> including a state-of-the-art fitness center, playground, and a unique beer garden. Each apartment features designer finishes and a chef-inspired kitchen, ensuring a living experience that crafts both comfort and style. Embrace the perfect blend of luxury and convenience right here in Demorest.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 20px;\"><strong>Experience the Best of Northeast Georgia</strong></span></h2><p>Life at Villas at Old 441 places you in the heart of one of North Georgia's most scenic communities.</p><p>Explore the charm of downtown Demorest and nearby Cornelia, spend weekends hiking local trails, visit area wineries, enjoy parks and outdoor recreation, or discover local restaurants and shops—all just minutes from home. With convenient access to Highway 441 and nearby Piedmont University, everything you need is within easy reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>We Love Pets!</strong></span></p><p>At Villas at Old 441 in Demorest, GA, your furry friends are part of the family! With a pet-friendly policy allowing up to two cats or dogs for just $20 each month, you can enjoy life in our charming community without leaving your beloved companions behind. Welcome home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Old 441 is a pet-friendly community! <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/contact\">Contact us if you have any questions</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>First Responders</p></li><li><p>Educators</p></li><li><p>Military &amp; Veterans</p></li><li><p>Law Enforcement</p></li><li><p>Delta Airlines</p></li><li><p>Medical Personnel</p></li><li><p>School System Employees</p></li><li><p>Amazon Fulfillment Center</p></li><li><p>Chik-fil-la</p></li><li><p>Postal Workers</p></li><li><p>Georgia Power</p></li><li><p>Lockheed Martin</p></li><li><p>Hartsfield-Jackson Airport</p></li><li><p>Government Employees</p></li><li><p>Johnson &amp; Johnson</p></li><li><p>Piedmont Employees &amp; Students</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life feels a little slower—and a lot more comfortable—at Villas at Old 441.</p><p>Nestled in the scenic foothills of Northeast Georgia, our thoughtfully designed one, two, and three-bedroom apartment homes combine modern style with the warmth of a welcoming community. Whether you're enjoying a quiet evening at home, meeting friends by the pool, or exploring everything Demorest has to offer, you'll find a lifestyle that feels both relaxing and connected.</p><p>Inside your apartment, contemporary finishes like granite countertops, stainless steel appliances, wood-style flooring, and spacious open layouts create a home that's as beautiful as it is functional. With an in-home washer and dryer included, everyday living becomes just a little easier.</p><p>Beyond your front door, inviting community spaces encourage you to unwind, stay active, and enjoy every season. Spend sunny afternoons by the sparkling pool, gather around the beer garden with neighbors, work out in the fitness center, or let your four-legged companion burn off energy at the bark park.</p><p>At Villas at Old 441, you'll discover more than a beautiful apartment—you'll find a place that truly feels like home.</p><p><strong>Schedule your personal tour today and experience it for yourself.</strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Villas at Old 441 in Demorest, GA, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">your ideal home awaits</a>—whether you seek a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/neighborhood\">Dive into the vibrant community</a> life and see what our residents love most. Schedule a tour today and envision your perfect living space!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 20px;\"><strong>Step Inside Villas at Old 441</strong></span></p><p>Get a closer look at life at Villas at Old 441 from wherever you are. Our interactive virtual tours let you explore apartment interiors, imagine your furniture in the space, and experience the thoughtful design that makes our community feel like home—all before your first visit.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019faac1-e4f1-728d-a60d-17eb37a3e719.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fun-filled pool party with diverse friends enjoying colorful floats together."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-1d65-739c-87ab-9f6003c16f47.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a central drive leading to parking areas."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 7,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff4ef-6fe2-729c-932a-8c1622fdfb87.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Primary bedroom with a queen-sized bed and green bedding, facing a large window with tree views."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019faac8-3be9-768b-987c-91459a0b66ca.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Couple laughing on a couch with a dog and laptop."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-3b5e-75b8-b69b-dc7f7f74c374.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor fire pit area with Adirondack chairs and two pergolas."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-3f49-772e-84dc-7b52a14ce937.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fef65-90a9-702d-8eed-1bb594ae09d6.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff4ef-7311-766d-b4bf-a7b1764342f7.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff4ef-467a-711b-9183-f35a37018f36.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff4ef-38c4-736a-8935-8e53e7d7ea2d.webp"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-1771-77ff-8381-9d87a6728eb8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and buildings in the background."
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and buildings in the background."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-1771-77ff-8381-9d87a6728eb8.webp"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff65a-8e9b-72a0-b2d7-898338a60ed7.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A joyful family enjoying a sunny day in a São Paulo park, highlighting togetherness and outdoor fun."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019faaba-62f6-713c-824f-228be95984f1.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of hikers enjoys a spring trek on the Lycian Way in Fethiye, Turkey."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[7].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[7].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019faac8-3be9-768b-987c-91459a0b66ca.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cheerful African American female with curly hair in casual clothes embracing obedient dog and laughing with black boyfriend sitting on sofa and browsing laptop in light room in apartment"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019faac4-8b87-73d7-86db-4ac5b48bccc3.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      }
    }
  },
  "preferredemployerhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019ff65c-9b19-7104-8657-c423017da5c0.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Diverse colleagues celebrating success with a high five in a modern office."
      }
    }
  },
  "preferredemployerprogram.benefit_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Waived Admin Fees"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Preferred employees receive a waived admin fee— subject to a qualifying credit check."
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule Your Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-4688-7739-8dc3-8bbe4e635dee.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered patio with outdoor seating area including a sofa, two chairs, and a coffee table."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167445/019fe962-5d63-71bd-b161-ca21b0e65923.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, green bedding, and a window overlooking trees."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_6f20f951-a2fe-4e96-a417-af7c574ff18e",
      "custom_e095a69e-4487-4085-a8fd-e89b2b3324ca",
      "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94",
      "custom_b42ec7cc-f645-43c8-80b7-70602d602154",
      "custom_30147c44-0c1a-44fd-805b-fdf6f0b6c8ed",
      "custom_9cb490cd-25cf-4cb7-a9a0-604d5427b8ba",
      "custom_671a5097-e4c0-48e6-a796-ebe5b4d72318",
      "custom_7324757a-60ad-4123-ac1f-0e63b5c7d5ac",
      "custom_5235da08-5137-4376-8288-1f5533b214e3",
      "custom_110fc755-7410-4c5d-bfa2-7d4acc7693cf",
      "custom_80bdace0-5d15-4030-887b-8881b705e2c0",
      "custom_92d48bd6-54db-4f84-8287-2ecb2b9667bd",
      "custom_65543a78-cb2a-4e7c-a285-db511664a963",
      "custom_da67017e-f0b8-4afd-8018-b9134fe62e56"
    ],
    "orderedIds": [
      "custom_01f32b06-474d-4fcd-8cd8-1762ac2472ad",
      "custom_c33c617f-fca3-4e24-bbbf-032bd00bba50",
      "custom_5011cc19-8f92-434d-b319-251e02ddf55a",
      "custom_8ab5a0ea-eec3-49cc-9833-6e0c30aa4851",
      "custom_3d548401-27d9-4cf4-a056-ca061ad4ecbe",
      "custom_0c2526ce-003f-4d76-9853-d96ea1e305f9",
      "custom_93c7c1c9-5fbf-4b3e-8043-256120509a16",
      "custom_155cce6c-5451-42dc-b45b-0e89f2d152df",
      "custom_d3217c80-1432-4d60-a456-d979efd6090d",
      "custom_e9d13f7f-778f-41a8-86ec-4a831dc640aa",
      "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94",
      "custom_da67017e-f0b8-4afd-8018-b9134fe62e56",
      "custom_671a5097-e4c0-48e6-a796-ebe5b4d72318",
      "custom_7324757a-60ad-4123-ac1f-0e63b5c7d5ac",
      "custom_5235da08-5137-4376-8288-1f5533b214e3",
      "custom_110fc755-7410-4c5d-bfa2-7d4acc7693cf",
      "custom_65543a78-cb2a-4e7c-a285-db511664a963",
      "custom_92d48bd6-54db-4f84-8287-2ecb2b9667bd",
      "custom_80bdace0-5d15-4030-887b-8881b705e2c0",
      "custom_6b8cac61-fdcc-4c38-a525-60285fe1a291",
      "custom_d9b9264c-a5c4-4634-beb9-37d64ee9ce57"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94"
    ],
    "orderedIds": [
      "custom_e9d13f7f-778f-41a8-86ec-4a831dc640aa",
      "custom_01f32b06-474d-4fcd-8cd8-1762ac2472ad",
      "custom_c33c617f-fca3-4e24-bbbf-032bd00bba50",
      "custom_5011cc19-8f92-434d-b319-251e02ddf55a",
      "custom_93c7c1c9-5fbf-4b3e-8043-256120509a16",
      "custom_0c2526ce-003f-4d76-9853-d96ea1e305f9",
      "custom_d9b9264c-a5c4-4634-beb9-37d64ee9ce57",
      "custom_6b8cac61-fdcc-4c38-a525-60285fe1a291",
      "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94",
      "custom_d3217c80-1432-4d60-a456-d979efd6090d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": 22,
    "hiddenIds": [
      "custom_e9d13f7f-778f-41a8-86ec-4a831dc640aa",
      "custom_6f20f951-a2fe-4e96-a417-af7c574ff18e",
      "custom_b42ec7cc-f645-43c8-80b7-70602d602154",
      "custom_30147c44-0c1a-44fd-805b-fdf6f0b6c8ed",
      "custom_9cb490cd-25cf-4cb7-a9a0-604d5427b8ba",
      "custom_4cd48336-e9fe-4f93-90ab-fa0699f940b9",
      "custom_a9390bf4-b2a4-4c95-b413-4e1766b85b01",
      "custom_6239bad1-1003-448b-9ce1-002cdcde2bf3",
      "custom_3cb9e7ba-38e0-47e9-8074-b458ee2781aa",
      "custom_9569c2ba-597e-456c-8da4-85814fe8f805",
      "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94"
    ],
    "orderedIds": [
      "custom_e9d13f7f-778f-41a8-86ec-4a831dc640aa",
      "custom_b5bf36b6-24ca-434d-b9e9-b62f608b8f94",
      "custom_155cce6c-5451-42dc-b45b-0e89f2d152df",
      "custom_8ab5a0ea-eec3-49cc-9833-6e0c30aa4851",
      "custom_3d548401-27d9-4cf4-a056-ca061ad4ecbe",
      "custom_92d48bd6-54db-4f84-8287-2ecb2b9667bd",
      "custom_80bdace0-5d15-4030-887b-8881b705e2c0",
      "custom_7324757a-60ad-4123-ac1f-0e63b5c7d5ac",
      "custom_65543a78-cb2a-4e7c-a285-db511664a963",
      "custom_5235da08-5137-4376-8288-1f5533b214e3",
      "custom_671a5097-e4c0-48e6-a796-ebe5b4d72318",
      "custom_110fc755-7410-4c5d-bfa2-7d4acc7693cf",
      "custom_da67017e-f0b8-4afd-8018-b9134fe62e56",
      "custom_c33c617f-fca3-4e24-bbbf-032bd00bba50",
      "custom_5011cc19-8f92-434d-b319-251e02ddf55a",
      "custom_93c7c1c9-5fbf-4b3e-8043-256120509a16",
      "custom_0c2526ce-003f-4d76-9853-d96ea1e305f9",
      "custom_01f32b06-474d-4fcd-8cd8-1762ac2472ad",
      "custom_d9b9264c-a5c4-4634-beb9-37d64ee9ce57",
      "custom_d3217c80-1432-4d60-a456-d979efd6090d",
      "custom_6b8cac61-fdcc-4c38-a525-60285fe1a291"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0,
      "visible": false
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
